/* unplugin-vue-components disabled */import { render } from "./templateStatusShow.vue?vue&type=template&id=3543a890&scoped=true"
import script from "./templateStatusShow.vue?vue&type=script&lang=js"
export * from "./templateStatusShow.vue?vue&type=script&lang=js"

import "./templateStatusShow.vue?vue&type=style&index=0&id=3543a890&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3543a890"]])

export default __exports__